// web/src/features/home/TempUnitToggle.tsx
import { useTempUnitDraft } from './tempUnit';
import type { TempUnit } from './types';

const OPTIONS: Array<{ unit: TempUnit; text: string; name: string }> = [
  { unit: 'f', text: '°F', name: 'Fahrenheit' },
  { unit: 'c', text: '°C', name: 'Celsius' },
];

// °F | °C while customizing My Home (renders nothing otherwise): sets the draft
// unit the greeting bar and the Weather tiles show at once; Save keeps it. In
// the Customize bar, and in the Weather tile's Configure where the unit used to
// be a per-tile setting.
export function TempUnitToggle({ className = '' }: { className?: string }) {
  const unit = useTempUnitDraft((s) => s.unit);
  const setUnit = useTempUnitDraft((s) => s.setUnit);
  if (!unit) return null;
  return (
    <div role="group" aria-label="Temperature unit" title="Temperature unit of the greeting and the Weather tile"
      className={`inline-flex shrink-0 rounded-[8px] bg-surface shadow-marked overflow-hidden ${className}`}>
      {OPTIONS.map((o) => (
        <button key={o.unit} type="button" aria-pressed={unit === o.unit} title={o.name}
          onClick={() => setUnit(o.unit)}
          className={`h-[24px] px-2 text-[0.75rem] leading-none transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary ${
            unit === o.unit ? 'bg-primary-light text-accent-strong font-semibold' : 'text-secondary hover:bg-row-highlight'}`}>
          {o.text}
        </button>
      ))}
    </div>
  );
}
